module.exports = __webpack_public_path__ + "assets/img/news (7).94acc3f2.png";